import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import CenteneAuthorizer from './components/CenteneAuthorizer';

const CenteneListQueueAvailabilityPage = lazy(() => import('./pages/queueAvailability/listQueueAvailabilityPage'));
const CenteneEditQueueAvailabilityPage = lazy(() => import('./pages/queueAvailability/editQueueAvailabilityPage'));
const CenteneListTransferPointsPage = lazy(() => import('./pages/transferPoints/listTransferPointsPage'));
const CenteneEditTransferPointsPage = lazy(() => import('./pages/transferPoints/editTransferPointPage'));

const CenteneBulkEditTransferPointsPage = lazy(() => import('./pages/transferPoints/bulkEditTransferPointsPage'));

const CenteneListPromptsPage = lazy(() => import('./pages/prompts/ListPromptsPage'));

const CenteneEditPromptPage = lazy(() => import('./pages/prompts/EditPromptPage'));
const CenteneBulkEditPromptPage = lazy(() => import('./pages/prompts/BulkEditPromptPage'));

const CentenePromptLookupPage = lazy(() => import('./pages/prompts/PromptLookupPage'));

const CenteneListAuditLogRecordsPage = lazy(() => import('./pages/auditLog/ListAuditLogRecordsPage'));

const CenteneBulkEditQueueAvailabilityPage = lazy(
  () => import('./pages/queueAvailability/BulkEditQueueAvailabilityPage')
);

/*
const CenteneListDnisPage = lazy(
  () => import('./pages/dnis/ListDnisPage')
);

const CenteneEditDnisPage = lazy(
  () => import('./pages/dnis/EditDnisPage')
);

const CenteneListNotificationsPage = lazy(() =>
  import("./pages/notifications/NotificationsPage")
);

const CenteneEditNotificationPage = lazy(() => import('./pages/notifications/EditNotificationPage'));

const CenteneListFeaturesPage = lazy(() => import('./pages/features/ListFeaturesPage'));

const CenteneEditFeaturePage = lazy(() =>
  import("./pages/features/EditFeaturePage")
);
*/
const CenteneListChangeRequestsPage = lazy(() => import('./pages/changeRequest/ListChangeRequestPage'));

export const CENTENE_ROUTES = {
  HOME: '/portal/centene',
  QUEUE_AVAILABILITY: {
    LIST: '/portal/centene/queue-availability',
    BULK_EDIT: '/portal/centene/queue-availability/bulk-edit',
    ITEM: {
      PATH: '/portal/centene/queue-availability/:node',
      buildPath: (node: string) => `/portal/centene/queue-availability/${node}`
    }
  },
  TRANSFER_POINTS: {
    LIST: '/portal/centene/transfer-points',
    ITEM: {
      PATH: '/portal/centene/transfer-points/:node',
      buildPath: (node: string) => `/portal/centene/transfer-points/${node}`
    },
    BULK_EDIT: '/portal/centene/transfer-points/bulk-edit'
  },
  PROMPTS: {
    LIST: '/portal/centene/prompts',
    ITEM: {
      PATH: '/portal/centene/prompts/:node',
      buildPath: (node: string) => `/portal/centene/prompts/${node}`
    },
    BULK_EDIT: '/portal/centene/prompts/bulk-edit'
  },
  PROMPT_LOOKUP: '/portal/centene/prompt-lookup',
  CHANGE_REQUESTS: {
    LIST: '/portal/centene/change-requests'
  },
  AUDIT_LOG: {
    LIST: '/portal/centene/audit-log'
  }
};

const routes: RouteObject[] = [
  {
    element: <CenteneAuthorizer />,
    children: [
      {
        path: CENTENE_ROUTES.HOME,
        element: <Navigate to='/' replace />
      },
      {
        path: CENTENE_ROUTES.QUEUE_AVAILABILITY.LIST,
        element: <CenteneListQueueAvailabilityPage />
      },
      {
        path: CENTENE_ROUTES.QUEUE_AVAILABILITY.BULK_EDIT,
        element: <CenteneBulkEditQueueAvailabilityPage />
      },
      {
        path: CENTENE_ROUTES.QUEUE_AVAILABILITY.ITEM.PATH,
        element: <CenteneEditQueueAvailabilityPage />
      },
      {
        path: CENTENE_ROUTES.TRANSFER_POINTS.ITEM.PATH,
        element: <CenteneEditTransferPointsPage />
      },
      {
        path: CENTENE_ROUTES.TRANSFER_POINTS.LIST,
        element: <CenteneListTransferPointsPage />
      },
      {
        path: CENTENE_ROUTES.TRANSFER_POINTS.BULK_EDIT,
        element: <CenteneBulkEditTransferPointsPage />
      },
      {
        path: CENTENE_ROUTES.PROMPTS.LIST,
        element: <CenteneListPromptsPage />
      },
      {
        path: CENTENE_ROUTES.PROMPTS.ITEM.PATH,
        element: <CenteneEditPromptPage />
      },
      {
        path: CENTENE_ROUTES.PROMPTS.BULK_EDIT,
        element: <CenteneBulkEditPromptPage />
      },
      {
        path: CENTENE_ROUTES.PROMPT_LOOKUP,
        element: <CentenePromptLookupPage />
      },
      {
        path: CENTENE_ROUTES.CHANGE_REQUESTS.LIST,
        element: <CenteneListChangeRequestsPage />
      },
      {
        path: CENTENE_ROUTES.AUDIT_LOG.LIST,
        element: <CenteneListAuditLogRecordsPage />
      }
    ]
  }
];

export default routes;
